
import { defineComponent, ref } from "vue";
import { IDutiesModel } from "@/interfaces/modules/security/IDutiesModel";
import { IUsersModel } from "@/interfaces/modules/security/IUsersModel";

import { useRoute } from "vue-router";
import router from "@/router";
import store from "@/store";
//Services
import DutiesService from "@/api/Security/DutiesService";
import UsersService from "@/api/Security/UsersService";

//components
import ImageUpload from "@/components/Common/ImageUpload.vue";
import UserSessionHistory from "./UserSessionHistory.vue";


export default defineComponent({
  name: "AddUser",
  components: {
    ImageUpload,
    UserSessionHistory
  },
  data() {
    const route = useRoute();
    const file = ref<File | null>(null);
    return {
      userId: route.params.id || 0,
      file: null as File | null,
      roles: [] as Array<IDutiesModel>,

      form: {
        loading: false,
        dialog: false,
        valid: false,
        record: {} as IUsersModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
    };
  },
  async mounted() {
    if (parseInt(this.userId as any) > 0)
      this.form.record = await UsersService.GetSystemUsersbyId(this.userId);
    this.getRoles();
  },
  methods: {
    async getRoles() {
      try {
        this.roles = await DutiesService.GetSystemDuties();
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    },
    handleFileChange(_file: any) {
      if (_file)
        this.file = _file
    },
    cancel() {
      router.push({ name: "Users" });
    },

    async handleSubmit(event) {
      event.preventDefault();
      this.form.loading = true;
      const formData = new FormData();
      formData.append("user", new Blob([JSON.stringify(this.form.record)], { type: "application/json" }));
      if (this.file) {
        formData.append("picture", this.file);
      }

      try {
        const res = await UsersService.PostSystemUsers(formData);
        this.form.loading = false;
        console.log("User saved successfully:", this.form.record);
        store.dispatch("core/popupDialog", {
          text: this.form.record.Id > 0? "Registro completado con éxito." : "Registro completado con éxito. Por favor activa la cuenta desde el correo enviado.",
          type: "success",
          showCancelButton: false,
        });
        this.cancel();

      } catch (err: any) {
        this.form.loading = false;
        console.log("Error saving user:", err);
        store.dispatch("core/popupDialog", {
          text: `Error: ${err?.response.data.message || "No se pudo guardar"}`,
          type: "error",
          showCancelButton: false,
        });
      }
    },
  },
});
